export default "__VITE_ASSET__CSkzFifT__"